import {BackendApi} from "./httpClient/backendApi";
import {AxiosError} from "axios";

export const logout = async (): Promise<null> => {
    const instance = BackendApi.getInstance()

    try {
        const response = await instance.instance
            .post('/auth/logout')

        if (!response.data) {
            return null;
        }
    } catch (error) {
        if (error instanceof AxiosError) {
            if (error.response) {
                throw error.response.data.detail;
            }
        }
    }

    return null;
}
